module.exports = __webpack_public_path__ + "static/media/012-Erkundigen_oV_ID_7.1afe9534.mp3";